function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "add_folder/24\\u044524"
}, React.createElement("path", {
  d: "M7.70710678,12.2928932 L7.79029539,12.3871006 C8.09532028,12.7793918 8.06759074,13.3466228 7.70710678,13.7071068 C7.34662282,14.0675907 6.77939176,14.0953203 6.38710056,13.7902954 L6.29289322,13.7071068 L1.29289322,8.70710678 L1.20970461,8.61289944 C0.930098463,8.25329917 0.930098463,7.74670083 1.20970461,7.38710056 L1.29289322,7.29289322 L6.29289322,2.29289322 L6.38710056,2.20970461 C6.74670083,1.93009846 7.25329917,1.93009846 7.61289944,2.20970461 L7.70710678,2.29289322 L7.79029539,2.38710056 C8.06990154,2.74670083 8.06990154,3.25329917 7.79029539,3.61289944 L7.70710678,3.70710678 L4.416,6.999 L8.99831969,7 C17.2098015,7 22.9947608,13.1145711 23,20.9993356 C23.0003667,21.5516202 22.5529491,21.9996328 22.0006644,22 C21.4483798,22.0003667 21.0003672,21.5529491 21,21.0006644 C20.9955482,14.3003484 16.2299856,9.16024725 9.32361385,9.00367616 L8.99831969,9 L4.414,8.999 L7.70710678,12.2928932 Z",
  id: "Path"
})));

var SvgIUndo = function SvgIUndo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIUndo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-undo.f246a63c.svg";
export { ForwardRef as ReactComponent };